import { useState, useEffect, useRef } from "react";
import api from "../lib/api";
import { MapPin } from "lucide-react";

export function AddressAutocomplete({ value, onChange, onSelect, placeholder, country, testid, dotColor = "#EC407A" }) {
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const skipRef = useRef(false);
  const boxRef = useRef(null);
  const reqRef = useRef(0);

  useEffect(() => {
    if (skipRef.current) { skipRef.current = false; return; }
    const q = (value || "").trim();
    if (q.length < 3) { setResults([]); setOpen(false); return; }
    const myId = ++reqRef.current;
    const id = setTimeout(async () => {
      try {
        const { data } = await api.get(`/geo/search`, { params: { q, country: country || "", limit: 6 } });
        if (myId !== reqRef.current) return; // requête périmée : on ignore
        setResults(data.results || []);
        setOpen((data.results || []).length > 0);
      } catch { if (myId === reqRef.current) setResults([]); }
    }, 350);
    return () => clearTimeout(id);
  }, [value, country]);

  useEffect(() => {
    const h = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const pick = (r) => {
    skipRef.current = true;
    onChange(r.label);
    onSelect?.(r);
    setOpen(false);
    setResults([]);
  };

  return (
    <div ref={boxRef} className="relative">
      <span className="absolute left-4 top-1/2 -translate-y-1/2 w-2.5 h-2.5 rounded-full z-10" style={{ background: dotColor }} />
      <input
        data-testid={testid}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => results.length && setOpen(true)}
        placeholder={placeholder}
        className="w-full h-14 rounded-2xl border-2 border-[#ECE7DF] focus:border-[#EC407A] outline-none pl-10 pr-4 text-[15px] transition-colors bg-white"
      />
      {open && results.length > 0 && (
        <div data-testid={`${testid}-list`} className="absolute z-[1200] left-0 right-0 mt-1.5 bg-white rounded-2xl border border-[#ECE7DF] shadow-[0_12px_40px_rgba(0,0,0,0.14)] overflow-hidden max-h-72 overflow-y-auto">
          {results.map((r, i) => (
            <button key={i} type="button" data-testid={`${testid}-opt-${i}`} onClick={() => pick(r)}
              className="w-full text-left px-4 py-3 flex items-start gap-2.5 hover:bg-[#FCE4EC] transition-colors border-b border-[#F3EFE8] last:border-0">
              <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-[#EC407A]" />
              <span className="text-sm text-[#1A1A1A] leading-snug">{r.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
